function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeReload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "101.9314 183.8653 15.0004 17.9999",
    width: "15.0004px",
    height: "17.9999px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M 110.785 195.012 C 110.98 195.207 110.98 195.524 110.785 195.719 L 108.139 198.365 L 110.785 201.012 C 110.98 201.207 110.98 201.524 110.785 201.719 C 110.59 201.914 110.273 201.914 110.078 201.719 L 106.724 198.365 L 110.078 195.012 C 110.273 194.816 110.59 194.816 110.785 195.012 Z",
    fill: "#1D1D46",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M 113.66 185.171 C 112.256 184.213 110.569 183.76 108.874 183.886 C 107.179 184.012 105.578 184.71 104.332 185.866 C 103.086 187.021 102.269 188.566 102.015 190.246 C 101.762 191.927 102.087 193.643 102.936 195.115 C 103.074 195.354 103.38 195.436 103.619 195.298 C 103.858 195.16 103.94 194.854 103.802 194.615 C 103.066 193.34 102.784 191.852 103.004 190.396 C 103.224 188.939 103.932 187.601 105.012 186.599 C 106.092 185.598 107.48 184.993 108.948 184.883 C 110.417 184.774 111.88 185.166 113.096 185.997 C 114.313 186.827 115.211 188.046 115.644 189.454 C 116.077 190.861 116.019 192.374 115.48 193.745 C 114.941 195.116 113.952 196.262 112.676 196.998 C 111.684 197.569 110.565 197.865 109.431 197.865 L 107.431 197.865 L 107.356 198.86 C 107.583 198.894 108.046 198.891 108.439 198.885 C 108.643 198.882 108.837 198.877 109.004 198.873 C 109.19 198.869 109.341 198.865 109.431 198.865 C 110.739 198.865 112.031 198.523 113.175 197.864 C 114.648 197.016 115.788 195.693 116.411 194.111 C 117.033 192.53 117.1 190.784 116.6 189.16 C 116.1 187.535 115.063 186.129 113.66 185.171 Z",
    fill: "#1D1D46",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M 112.17 187.456 C 112.365 187.651 112.365 187.968 112.17 188.163 L 109.524 190.809 L 112.17 193.456 C 112.365 193.651 112.365 193.968 112.17 194.163 C 111.975 194.358 111.658 194.358 111.463 194.163 L 108.109 190.809 L 110.625 188.294 L 111.463 187.456 C 111.658 187.26 111.975 187.26 112.17 187.456 Z",
    fill: "#1D1D46",
    style: {
      strokeWidth: 1,
      transformOrigin: "110.213px 190.809px"
    },
    transform: "matrix(0.70710701, -0.70710701, 0.70710701, 0.70710701, 0.00000864, -0.00000325)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeReload);
export default __webpack_public_path__ + "static/media/time-reload.ac49cb0d65c1ee206da233cd4ea2f71f.svg";
export { ForwardRef as ReactComponent };